import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Grid,
  Typography,
  Button,
  CircularProgress,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
} from "@material-ui/core";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import { selectImageToken } from "../../../features/userSlice";
import { openWebSite } from "../../../apis/util";
import { postRequest } from "../../../apis/axiosAction";
import {
  getKeieiShindanData,
  KEIEI_SHINDAN_BIG_RECORD,
  KEIEI_SHINDAN_OTHER_DATA,
  KEIEI_SHINDAN_TOTAL_SCORE,
} from "./KeieiShindanDataOperation";
import { DateTime } from "luxon";
import {
  getFixedFlg,
  setFixedFlg,
  setInitTenpoCode,
} from "../../Header/Header";
import { makeStyles } from "@material-ui/core/styles";
import { setLastKeieiShindanId, setKeieiShindanId } from "./KeieiShindan";
import { userLogging } from "../../../apis/userLog";
import KeieiShindanDialog from "../KeieiShindanDialog";
import {
  EXISTING_SEJ_STORES_RECORD,
  getAllExistingSejStores,
} from "../../../data/existingSejStores";
import { roundScore } from "./KeieiShindanCalculation";

const useStyles = makeStyles({
  card: {
    margin: 3,
  },
  button: {
    color: "#fff",
    backgroundColor: "#ef942a",
    fontSize: "20px",
    width: "40vw",
    height: "5vh",
    margin: "10px",
    "&:hover": {
      background: "#ef942a",
    },
  },
  contentFrame: {
    overflowY: "visible",
    height: "auto",
  },
  tableBodyCell: {
    padding: "0",
    verticalAlign: "top",
  },
  topSectionTitle: {
    minWidth: "5px",
    maxWidth: "70px",
    height: "30px",
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
    backgroundColor: "whitesmoke",
    alignItems: 'center',
  },
  character: {
    transformOrigin: 'center',
    display: 'block',
  },
  tableItemCell: {
    padding: "0",
    border: "1px solid #aaa",
    borderTop: "hidden",
  },

  noCell: {
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
    width: "17px",
    minWidth: "17px",
    backgroundColor: "whitesmoke",
  },
  itemCell: {
    padding: "0",
    paddingRight: "5px",
    paddingLeft: "5px",
    width: "100%",
    minWidth: "30vw",
    borderTop: "1px solid #aaa",
  },
  itemCell2: { padding: "0", width: "100vw" },
  okCell: {
    border: "1px solid #aaa",
    paddingTop: "0",
    paddingBottom: "0",
    textAlign: "center",
  },
  pointCell: {
    border: "1px solid #aaa",
    paddingTop: "0",
    paddingBottom: "0",
    textAlign: "center",
    minWidth: "30px",
  },
  minTableCell: {
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
  },
  right: {
    textAlign: "right",
  },
  empCell: {
    padding: "0",
    border: "none",
  },
  overLayer: {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    backgroundColor: "#CCC",
    opacity: "0.5",
    zIndex: 100000,
  },
  circularProgress: {
    position: "absolute",
    top: "35%",
    left: "45%",
    opacity: "0.8",
    color: "#ccc",
  },
});

let pdfUrl = "";
let pdfFlg = false;
export { pdfFlg };
let updateFlg = 0;

const buttonNamePrint = "印刷（PDFダウンロード）";
const buttonNameExcute = "登録（PDF作成）";

interface CustomVerticalProps {
  text?: string;
}

//文字を縦に変換する関数
const CustomVertical: React.FC<CustomVerticalProps> = ({ text = "" }) => {
  const classes = useStyles();

  const characters = (text || "").split('').map((char, index) => (
    <span key={index} className={classes.character}>{char}</span>
  ));

  return (
    <div>
      {characters}
    </div>
  );
}


// 曜日の取得
const getDayOfWeekText = (datetime: DateTime | null) => {
  if (!datetime) {
    return;
  }
  let weekDayArray: string[] = [];
  weekDayArray = ["月", "火", "水", "木", "金", "土", "日"];
  const dayOfWeek = datetime.weekday;
  return weekDayArray[dayOfWeek - 1];
};

const KeieiShindanResultPrint: React.FC<{
  tenpoCode: string;
  keieiShindanId: string;
  lastKeieiShindanId: string;
  setUpdateFlg: any;
}> = ({ tenpoCode, keieiShindanId, lastKeieiShindanId, setUpdateFlg }) => {
  const classes = useStyles();

  const [otherData, setOtherData] = React.useState<KEIEI_SHINDAN_OTHER_DATA>(
    {}
  );
  const [totalScore, setTotalScore] = React.useState("");
  const [pdfButtonName, setPdfButtonName] = React.useState(
    pdfUrl ? buttonNamePrint : buttonNameExcute
  );
  const [rowItemList, setRowItemList] = React.useState<
    KEIEI_SHINDAN_BIG_RECORD[]
  >([]);

  const [scoreItemList, setScoreItemList] = React.useState<
    KEIEI_SHINDAN_TOTAL_SCORE[]
  >([]);
  const [approvalDate, setApprovalDate] = React.useState<DateTime | null>(
    DateTime.local()
  );
  const [convertedApprovalDate, setConvertedApprovalDate] = React.useState<
    string | null
  >(null);
  const [pdfURL, setPdfURL] = React.useState("");
  const [pdfPath, setPdfPath] = React.useState("");
  const storeMaster: Map<String, EXISTING_SEJ_STORES_RECORD> =
    getAllExistingSejStores().store_data;
  // 店舗レコードを内部データから取得
  const storeRecord = storeMaster.get(tenpoCode);
  const tenpoName = storeRecord ? storeRecord.tenpo_name : "";
  const [click, setClick] = React.useState(false);
  const [creatWait, setCreatWait] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [alertFlg, setAlertFlg] = React.useState(false);
  const [dialogFlg, setDialogFlg] = React.useState(false);
  const [dialogNum, setDialogNum] = React.useState(0);

  // ダイアログ表示
  const dialogCancel = () => {
    if (dialogNum === 2) {
      setPdfButtonName(buttonNameExcute);
      setCreatWait(false);
      handleClick();
      setLoading(false);
    }
    setDialogFlg(false);
  };
  const dialogOK = () => {
    if (!alertFlg) {
      if (dialogNum === 1) {
        setPdfButtonName("PDF作成中…");
        setCreatWait(true);
        handlePdfPrint();
      } else if (dialogNum === 2) {
        updatePdfPrint();
      }
    }
    setDialogFlg(false);
  };

  const handleClick = () => {
    setClick((prev) => !click);
  };

  const imageToken = useSelector(selectImageToken);

  function getPdfURL() {
    return (
      process.env.REACT_APP_CLOUD_STORAGE_URL +
      pdfPath +
      "?access_token=" +
      imageToken
    );
  }

  useEffect(() => {
    if (!getFixedFlg()) {
      setPdfURL("");
      setPdfButtonName(buttonNameExcute);
    }
  }, [tenpoCode]);

  useEffect(() => {
    setLoading(true);
    userLogging("KeieiShindan", "印刷#初期表示", keieiShindanId);
    setApprovalDate(null);
    setConvertedApprovalDate("");
    getKeieiShindanData(tenpoCode, keieiShindanId, lastKeieiShindanId).then(
      (res: any) => {
        setApprovalDate(
          res.approve_day
            ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
            : null
        );
        setConvertedApprovalDate(res.approve_day);
        setPdfPath(res.pdf_path);

        setRowItemList(res.rows);
        setOtherData(res.other_data);

        console.log("score_data.scores:", res.score_data.scores);
        setScoreItemList(res.score_data.scores);
        setTotalScore(res.score_data.total_score);

        if (getFixedFlg()) {
          setPdfURL(getPdfURL());
          setPdfButtonName(buttonNamePrint);
        }
        setLoading(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keieiShindanId]);

  const history = useHistory();
  function clickReference(
    tenpoCode: string,
    keieiShindanId: string,
    lastKeieiShindanId: string
  ) {
    setFixedFlg(true);
    setLastKeieiShindanId(lastKeieiShindanId);
    setKeieiShindanId(keieiShindanId);
    setInitTenpoCode(tenpoCode);
    // 画面遷移
    history.push("keiei-shindan");
  }

  function clickPdfPrint() {
    if (creatWait) {
      return;
    }
    if (pdfURL) {
      openWebSite(getPdfURL());
      return;
    }
    if (!checkInputKeieiShindan()) {
      setAlertFlg(true);
      setDialogMessage([
        "未入力項目があります。",
        "入力内容を確認してください",
      ]);
      setDialogFlg(true);
      return;
    }
    if (!convertedApprovalDate) {
      setAlertFlg(true);
      setDialogMessage(["作成日を入力してください"]);
      setDialogFlg(true);
      return;
    }

    if (getFixedFlg()) {
      setPdfButtonName("PDF作成中…");
      setCreatWait(true);
      handlePdfPrint();
    } else {
      setAlertFlg(false);
      setDialogNum(1);
      setDialogMessage([
        "作成日 " +
          (approvalDate ? approvalDate.toFormat("yyyy年MM月dd日") : "") +
          " でPDF作成します。",
        "PDFの出力後に編集は行えません。",
        "よろしいですか？",
      ]);
      setDialogFlg(true);
      return;
    }
  }

  function checkInputKeieiShindan() {
    let result = true;
    for (let i = 0; i < rowItemList.length; i++) {
      for (let j = 0; j < rowItemList[i].rows.length; j++) {
        if (
          rowItemList[i].rows[j].score === "" ||
          rowItemList[i].rows[j].score === null
        ) {
          result = false;
          break;
        }
      }
    }
    return result;
  }

  // 入力値比較
  const checkLatestRecord = (base: any[], check: any[]) => {
    for (let i = 0; i < base.length; i++) {
      if (base[i].rows.length !== check[i].rows.length) {
        return false;
      }
      for (let j = 0; j < base[i].rows.length; j++) {
        let baseRow = base[i].rows[j];
        let checkRow = check[i].rows[j];
        if (
          baseRow.big_item_id !== checkRow.big_item_id ||
          baseRow.small_item_id !== checkRow.small_item_id ||
          baseRow.score !== checkRow.score
        ) {
          return false;
        }
      }
    }
    return true;
  };

  const checkLatestData = (base: any, check: any) => {
    if (
      base.measures !== check.measures ||
      base.task !== check.task
    ) {
      return false;
    }
    return true;
  };

  const handlePdfPrint = async () => {
    setLoading(true);

    // 次回のKeieiShindanのデータを作成
    await getKeieiShindanData(
      tenpoCode,
      keieiShindanId,
      lastKeieiShindanId
    ).then((res: any) => {
      let ckRowItemList = res.rows;
      let ckOtherData = res.other_data;

      // 画面の最新状態との比較
      if (
        convertedApprovalDate !== res.approve_day ||
        !checkLatestRecord(rowItemList, ckRowItemList) ||
        !checkLatestData(otherData, ckOtherData)
      ) {
        setPdfButtonName(buttonNameExcute);
        setCreatWait(false);
        handleClick();
        setLoading(false);
        setAlertFlg(true);
        setDialogNum(3);
        setDialogMessage([
          "他の画面から内容が変更されています。",
          "一度画面を閉じてから再度、当該店舗の情報を開いて",
          "内容を確認の上、提出してください。",
        ]);
        setDialogFlg(true);
        return;
      } else {
        const apiParams = {
          id: keieiShindanId,
          approve_day: convertedApprovalDate,
          newFlag: true,
        };
        const url = process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/data-phase2";
        setCreatWait(true);
        postRequest(url, apiParams)
          .then(async (res) => {
            // 同一店舗同一週有りの場合、上書きの確認メッセージ表示
            if (res.data.dataList[0] === "SameStoreSameMonth") {
              if (getFixedFlg()) {
                updatePdfPrint();
                // 処理を終了する
                return;
              } else {
                setLoading(false);
                setCreatWait(false);
                setAlertFlg(false);
                setDialogNum(2);
                setDialogMessage(["上書き保存されますがよろしいですか？"]);
                setDialogFlg(true);
                // 処理を終了する
                return;
              }
            }
            // 完了済みのレコードの場合
            else if (res.data.dataList[0] === "AlreadyCompleted") {
              setPdfButtonName(buttonNameExcute);
              setCreatWait(false);
              handleClick();
              setLoading(false);
              setAlertFlg(true);
              setDialogNum(3);
              setDialogMessage([
                "既に登録されています。",
                "新たにデータ登録する場合は左上のメニューから「新規作成」を、",
                "作成されたデータを見る場合は左上のメニューからデータ検索してください。",
              ]);
              setDialogFlg(true);
              return;
            }
            // Firestoreへの入力内容に不備がある場合
            else if (res.data.dataList[0] === "InvalidFirestoreSave") {
              setPdfButtonName(buttonNameExcute);
              setCreatWait(false);
              handleClick();
              setLoading(false);
              setAlertFlg(true);
              setDialogNum(3);
              setDialogMessage([
                "入力内容が正常に保存できませんでした。",
                "メニューより「新規作成」を開き、対象店舗を選択して再度登録を実施してください。",
              ]);
              setDialogFlg(true);
              return;
            }
            const obj = JSON.parse(res.data.dataList[0]);
            setPdfURL(obj["url"]);
            setPdfButtonName(buttonNamePrint);
            setPdfPath(obj["path"]);
            setCreatWait(false);
            handleClick();
            setLoading(false);
            updateFlg++;
            setUpdateFlg(updateFlg);
            clickReference(tenpoCode, keieiShindanId, lastKeieiShindanId);
          })
          .catch((r) => {
            setCreatWait(false);
            setLoading(false);
            setAlertFlg(true);
            setDialogMessage([String(r)]);
            setDialogFlg(true);
          });
      }
    });
  };

  const updatePdfPrint = async () => {
    setLoading(true);
    setCreatWait(true);
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/data-phase2";
    const apiParams2 = {
      id: keieiShindanId,
      approve_day: convertedApprovalDate,
      newFlag: false,
    };
    await postRequest(url, apiParams2).then((res2) => {
      const obj = JSON.parse(res2.data.dataList[0]);
      setPdfURL(obj["url"]);
      setPdfButtonName(buttonNamePrint);
      setPdfPath(obj["path"]);
      setCreatWait(false);
      handleClick();
      setLoading(false);
      updateFlg++;
      setUpdateFlg(updateFlg);

      clickReference(tenpoCode, keieiShindanId, lastKeieiShindanId);
    });
    // 処理を終了する
    return;
  };

  return (
    <>
      {loading && <div className={classes.overLayer}></div>}
      {loading && (
        <CircularProgress className={classes.circularProgress} size={120} />
      )}
      {rowItemList && rowItemList.length > 0 ? (
        <>
          <Grid container className={classes.contentFrame}>
            {/* ヘッダー部↓ここから */}
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                backgroundColor: "gray",
                height: "50px",
                color: "white",
              }}
              direction="row"
            >
              <Grid
                container
                justify="flex-start"
                direction="column"
                xs
                lg={3}
                md={3}
                sm={3}
              >
                <Typography variant="h5">店舗経営診断</Typography>
              </Grid>
              <Grid
                container
                justify="center"
                direction="column"
                xs
                lg={5}
                md={5}
                sm={5}
              >
                <Typography variant="h5">{tenpoName}</Typography>
              </Grid>
              <Grid
                container
                justify="flex-end"
                direction="column"
                xs
                lg={3}
                md={3}
                sm={3}
              >
                <Typography variant="h5">
                  {approvalDate
                    ? approvalDate.toFormat("yyyy/MM/dd") +
                      "(" +
                      getDayOfWeekText(approvalDate) +
                      ")"
                    : ""}
                </Typography>
              </Grid>
            </Grid>
            {/* ヘッダー部↑ここまで */}
            {/* 表メイン↓ここから */}
            <Grid
              container
              justify="center"
              alignItems="center"
              direction="row"
            >
              <Table>
                {(() => {
                  const result: JSX.Element[] = [];
                  let currentGroup: string | undefined = undefined;
                  let groupFirstIndex = -1;

                  rowItemList.forEach((row, index) => {
                    // グループが変わった場合
                    if (row.big_item_group !== currentGroup) {
                      currentGroup = row.big_item_group;
                      groupFirstIndex = index;
                    }

                    // グループ内の行数をカウント
                    const groupRowCount = currentGroup
                      ? rowItemList.filter(r => r.big_item_group === currentGroup).length
                      : 0;

                    // グループの最初の行かチェック
                    const isFirstInGroup = currentGroup && index === groupFirstIndex;

                    result.push(
                      <TableRow key={`print-row-${index}`}>
                        {/* 左列1: 遵守項目ラベル（グループの最初の行のみrowSpan） */}
                        {isFirstInGroup && (
                          <TableCell
                            className={classes.topSectionTitle}
                            rowSpan={groupRowCount}
                            style={{
                              writingMode: "vertical-rl",
                              textAlign: "center",
                              fontWeight: "bold",
                              minWidth: "5px",
                              maxWidth: "45px",
                              width: "45px"
                            }}
                          >
                            {currentGroup}：「〇」or「×」
                          </TableCell>
                        )}

                        {/* 左列2: 大項目名（縦書き） - グループに属さない場合はcolSpan=2で左端から */}
                        <TableCell
                          className={classes.topSectionTitle}
                          colSpan={!currentGroup ? 2 : 1}
                        >
                          <CustomVertical text={row.big_title} />
                        </TableCell>

                        {/* 右側: 小項目一覧 */}
                        <TableCell className={classes.tableItemCell}>
                          {/* ヘッダー行を各大項目の最初に追加 */}
                          <TableRow key={`header-${index}`}>
                            <TableCell className={classes.noCell} style={{ backgroundColor: "whitesmoke", fontWeight: "bold" }}>
                              No
                            </TableCell>
                            <TableCell className={classes.itemCell} style={{ backgroundColor: "whitesmoke", fontWeight: "bold" }}>
                              項目
                            </TableCell>
                            {(row.big_item_id === 1 || row.big_item_id === 2 || row.big_item_id === 3) && (
                              <TableCell className={classes.pointCell} style={{ backgroundColor: "whitesmoke", fontWeight: "bold", whiteSpace: "nowrap" }}>
                                前々回
                              </TableCell>
                            )}
                            <TableCell className={classes.pointCell} style={{ backgroundColor: "whitesmoke", fontWeight: "bold", whiteSpace: "nowrap" }}>
                              前回
                            </TableCell>
                            <TableCell className={classes.pointCell} style={{ backgroundColor: "whitesmoke", fontWeight: "bold", whiteSpace: "nowrap" }}>
                              今回
                            </TableCell>
                          </TableRow>
                          {row.rows.map((rowData: any, rowDataIndex: number) => (
                            <TableRow key={`detail-${index}-${rowDataIndex}`}>
                              <TableCell className={classes.noCell}>
                                {rowData.small_item_no}
                              </TableCell>
                              <TableCell className={classes.itemCell}>
                                <TableRow>{rowData.small_title1}</TableRow>
                                {rowData.small_title2
                                  ? "　　" + rowData.small_title2
                                  : ""}
                              </TableCell>

                              {/* 前々回列（遵守項目のみ） */}
                              {(row.big_item_id === 1 || row.big_item_id === 2 || row.big_item_id === 3) && (
                                <TableCell className={classes.pointCell}>
                                  {rowData.before_last_score || rowData.before_last_score === "0"
                                    ? (rowData.before_last_score === "0" ? "〇" : rowData.before_last_score === "1" ? "×" : "―")
                                    : "―"}
                                </TableCell>
                              )}

                              {/* 前回列 */}
                              <TableCell className={classes.pointCell}>
                                {rowData.last_score || rowData.last_score === "0"
                                  ? (row.big_item_id === 1 || row.big_item_id === 2 || row.big_item_id === 3)
                                    ? (rowData.last_score === "0" ? "〇" : rowData.last_score === "1" ? "×" : "―")
                                    : rowData.last_score + "点"
                                  : "―"}
                              </TableCell>

                              {/* 今回列 */}
                              <TableCell className={classes.pointCell}>
                                {rowData.score || rowData.score === 0
                                  ? (row.big_item_id === 1 || row.big_item_id === 2 || row.big_item_id === 3)
                                    ? (rowData.score === "0" ? "〇" : rowData.score === "1" ? "×" : "―")
                                    : rowData.score + "点"
                                  : "―"}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableCell>
                      </TableRow>
                    );

                    // 遵守項目グループの最後の行の後に×の個数を表示
                    const isLastInGroup = currentGroup &&
                      index === groupFirstIndex + groupRowCount - 1;

                    if (isLastInGroup && currentGroup === "遵守項目") {
                      const complianceItems = scoreItemList.filter(
                        (item) => item.no === "1" || item.no === "2" || item.no === "3"
                      );
                      const totalMinusCount = complianceItems.reduce(
                        (sum, item) => sum + Number(item.score || 0),
                        0
                      );

                      // 前回・前々回の×の個数を計算
                      const complianceRows = rowItemList
                        .filter(r => r.big_item_id === 1 || r.big_item_id === 2 || r.big_item_id === 3)
                        .flatMap(r => r.rows);

                      const lastMinusCount = complianceRows.reduce(
                        (sum, row) => sum + (row.last_score === "1" ? 1 : 0),
                        0
                      );

                      const beforeLastMinusCount = complianceRows.reduce(
                        (sum, row) => sum + (row.before_last_score === "1" ? 1 : 0),
                        0
                      );

                      // 直近3回合計
                      const totalThreeTimesMinusCount = beforeLastMinusCount + lastMinusCount + totalMinusCount;

                      result.push(
                        <TableRow key="compliance-summary">
                          <TableCell
                            className={classes.tableItemCell}
                            colSpan={3}
                            style={{
                              border: "1px solid #aaa",
                              backgroundColor: "white",
                              padding: "16px 8px",
                            }}
                          >
                            <TableRow>
                              <TableCell className={classes.noCell} style={{ border: "none", backgroundColor: "white" }}>
                              </TableCell>
                              <TableCell
                                className={classes.itemCell}
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  fontWeight: "bold",
                                  fontSize: "20px",
                                  paddingRight: "16px",
                                  backgroundColor: "white",
                                }}
                              >
                                遵守項目：「×」の項目（直近3回合計）
                              </TableCell>
                              <TableCell className={classes.pointCell} colSpan={3} style={{ border: "none", backgroundColor: "white", fontSize: "16px", fontWeight: "bold" }}>
                                {totalThreeTimesMinusCount}個
                              </TableCell>
                            </TableRow>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  });

                  return result;
                })()}
              </Table>
            </Grid>
            {/* 表メイン↑ここまで */}

            <Grid style={{ padding: "10px" }}></Grid>

            {/* その他↓ここから */}
            <Grid container direction="row">
              <Grid style={{ padding: "10px" }}></Grid>

              {/* グラフ・得点↓ここから */}
              <Grid container direction="row" justify="flex-end">
                <Grid container direction="column" xs lg={6} md={6} sm={6}>
                  <Table>
                    <TableHead
                      style={{
                        border: "1px solid #aaa",
                        backgroundColor: "whitesmoke",
                      }}
                    >
                      <TableCell
                        className={classes.minTableCell}
                      >
                        項目
                      </TableCell>
                      <TableCell
                        className={classes.minTableCell}
                        style={{ textAlign: "center", minWidth: "120px", whiteSpace: "nowrap" }}
                      >
                        得点
                      </TableCell>
                      <TableCell
                        className={classes.minTableCell}
                        style={{ textAlign: "center", minWidth: "120px", whiteSpace: "nowrap" }}
                      >
                        満点
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      {scoreItemList
                        .filter((row) => row.no !== "1" && row.no !== "2" && row.no !== "3")
                        .map((row, index) => (
                          <TableRow key={`score-${index}`}>
                            <TableCell
                              className={classes.minTableCell}
                              style={{ textAlign: "center" }}
                            >
                              {row.name}
                            </TableCell>
                            <TableCell
                              className={classes.minTableCell}
                              style={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {roundScore(row.score)}
                            </TableCell>
                            <TableCell
                              className={classes.minTableCell}
                              style={{ textAlign: "center", whiteSpace: "nowrap" }}
                            >
                              {row.max_score || 0}
                            </TableCell>
                          </TableRow>
                        ))}
                      <TableRow>
                        <TableCell
                          className={classes.minTableCell}
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            backgroundColor: "#FFE4CC"
                          }}
                        >
                          合計
                        </TableCell>
                        <TableCell
                          className={classes.minTableCell}
                          style={{
                            textAlign: "center",
                            fontSize: "16px",
                            whiteSpace: "nowrap",
                            backgroundColor: "#FFE4CC"
                          }}
                        >
                          {totalScore}
                        </TableCell>
                        <TableCell
                          className={classes.minTableCell}
                          style={{
                            textAlign: "center",
                            fontSize: "16px",
                            whiteSpace: "nowrap",
                            backgroundColor: "#FFE4CC"
                          }}
                        >
                          100
                        </TableCell>
                      </TableRow>
                      {(() => {
                        const complianceItems = scoreItemList.filter(
                          (item) => item.no === "1" || item.no === "2" || item.no === "3"
                        );
                        const totalMinusCount = complianceItems.reduce(
                          (sum, item) => sum + Number(item.score || 0),
                          0
                        );

                        // 前回・前々回の×の個数を計算
                        const complianceRows = rowItemList
                          .filter(r => r.big_item_id === 1 || r.big_item_id === 2 || r.big_item_id === 3)
                          .flatMap(r => r.rows);

                        const lastMinusCount = complianceRows.reduce(
                          (sum, row) => sum + (row.last_score === "1" ? 1 : 0),
                          0
                        );

                        const beforeLastMinusCount = complianceRows.reduce(
                          (sum, row) => sum + (row.before_last_score === "1" ? 1 : 0),
                          0
                        );

                        // 直近3回合計
                        const totalThreeTimesMinusCount = beforeLastMinusCount + lastMinusCount + totalMinusCount;

                        return (
                          <TableRow>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                fontWeight: "bold",
                                textAlign: "center"
                              }}
                            >
                              遵守項目
                            </TableCell>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                textAlign: "center",
                                fontSize: "16px",
                                whiteSpace: "nowrap"
                              }}
                            >
                              「×」の項目（直近3回合計）
                            </TableCell>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                textAlign: "center",
                                fontSize: "16px",
                                whiteSpace: "nowrap"
                              }}
                            >
                              {totalThreeTimesMinusCount}
                            </TableCell>
                          </TableRow>
                        );
                      })()}
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
              {/* グラフ・課題・対策↑ここまで */}
              <Grid style={{ padding: "10px" }}></Grid>
            </Grid>
            {/* その他↑ここまで */}
          </Grid>
          {/* 印刷ボタン↓ここから */}
          <Grid container justify="center" alignItems="center">
            <Button
              variant="contained"
              className={classes.button}
              onClick={() => {
                userLogging("KeieiShindan", "印刷#帳票出力", "");
                clickPdfPrint();
              }}
            >
              {pdfButtonName}
              {pdfURL ? <DownloadIcon /> : ""}
            </Button>
          </Grid>
          {/* 印刷ボタン↑ここまで */}
        </>
      ) : (
        ""
      )}

      <KeieiShindanDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogOK}
        doNo={dialogCancel}
        isAlert={alertFlg}
      />
    </>
  );
};

export default KeieiShindanResultPrint;
